var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemove = function SvgRemove(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5H30.5V32C30.5 32.7956 30.1837 33.5586 29.6211 34.1213C29.0585 34.6839 28.2956 35 27.5 35H12.5C11.7043 35 10.9411 34.6839 10.3785 34.1213C9.81593 33.5586 9.5 32.7956 9.5 32V12.5Z",
    stroke: "#EE202C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5H10.4748C11.0714 12.4988 11.6541 12.3198 12.1484 11.9858C12.6427 11.6519 13.0263 11.178 13.25 10.625L14.75 6.89001C14.9714 6.33419 15.3538 5.85717 15.8483 5.52039C16.3427 5.1836 16.9265 5.00241 17.5248 5H22.4748C23.0731 5.00241 23.6569 5.1836 24.1514 5.52039C24.6458 5.85717 25.0286 6.33419 25.25 6.89001L26.75 10.625C26.9746 11.1804 27.3602 11.6559 27.8574 11.99C28.3547 12.3242 28.9407 12.5018 29.5398 12.5H35",
    stroke: "#EE202C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Remove.98edfb9f2888400b6072bb6860fafa58.svg";